/**
 * 학교연감 데이터
 */
const YearBookData = [
    {
        "book_id": 10396,
        "book_title": "(監理敎會協成神學校) 協成神學校年鑑 ",
        "book_title_ko": "(감리교회협성신학교) 협성신학교년감 ",
        "publish_date": "1926.00.00",
        "publish_year": 1926,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "監理敎會協成神學校",
        "publisher_ko": "감리교회협성신학교",
        "library": "",
        "school_id": 52940,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10396,
        "book_title": "(監理敎會協成神學校) 協成神學校年鑑 ",
        "book_title_ko": "(감리교회협성신학교) 협성신학교년감 ",
        "publish_date": "1926.00.00",
        "publish_year": 1926,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "監理敎會協成神學校",
        "publisher_ko": "감리교회협성신학교",
        "library": "",
        "school_id": 52757,
        "primaryname": "監理敎會協成神學校",
        "primaryname_ko": "감리교회협성신학교"
    },
    {
        "book_id": 10397,
        "book_title": "(朝鮮耶蘇敎長老敎神學校) 朝鮮耶蘇敎長老會年鑑 ",
        "book_title_ko": "(조선야소교장로교신학교) 조선야소교장로회년감 ",
        "publish_date": "1940.11.14",
        "publish_year": 1940,
        "publish_month": 11,
        "publish_day": 14,
        "publisher": "朝鮮耶蘇敎長老會",
        "publisher_ko": "조선야소교장로회",
        "library": "△",
        "school_id": 52770,
        "primaryname": "朝鮮耶蘇敎長老敎神學校",
        "primaryname_ko": "조선야소교회장로회신학교"
    }

]

export default YearBookData;